import { render, staticRenderFns } from "./HowWeCounted.vue?vue&type=template&id=987ceaf0&scoped=true"
import script from "./HowWeCounted.vue?vue&type=script&lang=js"
export * from "./HowWeCounted.vue?vue&type=script&lang=js"
import style0 from "./HowWeCounted.vue?vue&type=style&index=0&id=987ceaf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987ceaf0",
  null
  
)

export default component.exports